export const PRODUCT = {
  id: 'ditoo-pro',
  name: 'Divoom Ditoo-Pro Retro Pixel Art Bluetooth Speaker',
  price: 11500,
  mrp: 15889.39,
  reviewsCount: 233,
  descriptionPoints: [
    'Fun gadget to kill boredom: Create pixel art with your fingertips or explore 1,000+ designs in the free Divoom community. Chat, comment, and connect with creators.',
    'Cute Bluetooth speaker with DIY equalizer: 10W DSP-tuned audio; your pixel art dances to the beat-perfect for kawaii desks and gaming setups.',
    'Smile maker: Adorable and fun to play with. Stream music via Bluetooth; surprisingly good sound for work, study, or home workouts/classes.',
    'Smart alarm/clock for better sleep: Use as a desk clock or bedside alarm. App white noise helps you relax; plus optional social notifications, thermometer, and weather.',
    'Perfect gift idea: Gift-ready packaging with personalized greetings-great for birthdays, Christmas, graduations, and other holidays.'
  ],
  note: "After connecting the app, you must also connect your phone's Bluetooth to play music properly!",
  colors: [
    { name: 'White', image: '/ditoo-pro-white.webp' },
    { name: 'Pink', image: '/ditoo-pro-pink.webp' },
    { name: 'Black', image: '/ditoo-pro-black.webp' },
    { name: 'Green', image: '/ditoo-pro-green.webp' },
    { name: 'Blue', image: '/ditoo-pro-blue.webp' }
  ],
  trustItems: [
    'Free shipping',
    'Money-Back Guarantee',
    'Support 24/7',
    'Easy Returns and Exchanges'
  ],
  belowHeroImage: '/below-hero-section.png',
  sliderImages: [
    '/product-image-01.webp',
    '/product-image-02.webp',
    '/product-image-03.webp',
    '/product-image-04.webp',
    '/product-image-05.webp'
  ],
  biggerImage: '/bigger-image-display.webp',
  footerImage: '/footer-image.webp',
  videoEmbed:
    'https://www.youtube.com/embed/c2p3kbcbNEc?autoplay=1&mute=1&controls=0&modestbranding=1&rel=0&loop=1&playlist=c2p3kbcbNEc'
};

export const SAMPLE_REVIEWS = [
  {
    name: 'Aarav S.',
    title: 'Perfect desk vibe',
    body: 'Looks premium, sounds clear, and the pixel display gets attention every time someone visits my room.'
  },
  {
    name: 'Meher K.',
    title: 'Best gift purchase',
    body: 'Bought it as a gift and the packaging plus customization made it feel really special.'
  },
  {
    name: 'Rohan P.',
    title: 'App features are crazy',
    body: 'Community pixel designs and custom animations are super fun. Exactly what I wanted from Ditoo-Pro.'
  }
];
